import React from 'react';
import { Pressable, View, Icon, Modal } from 'react-native';
import PropTypes from 'prop-types';
import { Device } from 'DeviceUtils';
import { Portal } from '@gorhom/portal';
import registerIconFont from './registerTriangleIcon';
import { getIconPosition } from '../utils';
import { DROPDOWN_MENU_TEST_ID } from '../constants';
import defaultStyles, { ICON_SIZE } from './Dropdown.jss';

registerIconFont();
const fontName = 'materialCommunityIcons';

const DropDownMenuWrapper = ({
    children,
    menuContainerStyle,
    menuPosition,
    withArrow,
    closeDropDown,
    portal
}) => {
    const { vertical, horizontal, ...positionCoords } = menuPosition;

    const content = (
        <Pressable onPress={closeDropDown} style={defaultStyles.content}>
            <View
                style={[
                    {
                        ...defaultStyles.modal,
                        ...positionCoords,
                        ...(withArrow ? defaultStyles.withArrow : {}),
                        ...menuContainerStyle
                    }
                ]}
                testID={DROPDOWN_MENU_TEST_ID}
            >
                {children}
                {withArrow ? (
                    <Icon
                        style={{
                            ...getIconPosition({ vertical, horizontal }, ICON_SIZE),
                            ...defaultStyles.icon
                        }}
                        size={10}
                        font={fontName}
                        name="triangle"
                        color={menuContainerStyle.backgroundColor || 'transparent'}
                    />
                ) : null}
            </View>
        </Pressable>
    );
    if (Device.isWeb)
        return (
            <Modal
                visible
                transparent
                onDismiss={() => {
                    closeDropDown();
                }}
            >
                {content}
            </Modal>
        );

    if (portal) return <Portal hostName="picker-dropdown">{content}</Portal>;
    return content;
};

DropDownMenuWrapper.defaultProps = {
    children: null,
    menuContainerStyle: {},
    portal: false
};

DropDownMenuWrapper.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    closeDropDown: PropTypes.func.isRequired,
    menuContainerStyle: PropTypes.shape({}),
    menuPosition: PropTypes.shape({}).isRequired,
    withArrow: PropTypes.bool.isRequired,
    portal: PropTypes.bool
};
export default DropDownMenuWrapper;
